import {useState} from 'react';

const useErrorCounter = (count: number) => {
  const [errorStates, setErrorStates] = useState<boolean[]>(Array(count).fill(false));
  const isError = errorStates.every((state) => state);

  function emitError(index: number) {
    setErrorStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[index] = true;
      return newStates;
    });
  }

  function isErrorAtIndex(index: number) {
    return errorStates[index];
  }

  return {
    isError,
    emitError,
    isErrorAtIndex,
  };
};

export default useErrorCounter;
